import ApiCore from "../utilities/core";

const url = 'forms';
const plural = 'forms';
const single = 'form';

export const apiForms = new ApiCore({
    getAll: true,
    getSingle: true,
    post: true,
    put: true,
    patch: true,
    delete: true,
    url: url,
    plural: plural,
    single: single,
    requireToken: true
});

